import reducers from "./mapReducers";

export default reducers;
